import { gql } from '@apollo/client';

export const ReviewSectionsQuery = gql`
  query reviewSections {
    reviewSections @rest(type: "ReviewSections", path: "reviewSections.json/") {
      id
      name
      description
    }
  }
`;

export const TransactionQuery = gql`
  query transaction($jeId: String!) {
    transaction(jeId: $jeId) @rest(type: "JournalEntry", path: "document.json/:jeId") {
      id
      documentDate
      vendor
      dataEntries
      journalEntryId
      internalNotes
      amount
    }
  }
`;

export const ReviewChecksQuery = gql`
  query reviewChecks(
    $sectionId: String!
    $clientId: String!
    $startDate: String!
    $endDate: String!
  ) {
    reviewChecks(
      sectionId: $sectionId
      clientId: $clientId
      startDate: $startDate
      endDate: $endDate
    )
      @rest(
        type: "ReviewChecks"
        path: "reviewChecks.json/section/:sectionId/client/:clientId/:startDate/:endDate"
      ) {
      id
      code
      reviewSectionId
      ledgerId
      heading
      description
      isApplicable
      accountType
      journalEntries {
        id
        documentDate
        vendor
        dataEntries
        journalEntryId
        internalNotes
        amount
      }
      mostIncompleteStatus
      applicableLedgerCodes
      applicableLedgerIds
    }
  }
`;

export const ReviewMutation = gql`
  mutation submitReview($review: Object!) {
    submitReview(input: $review) @rest(type: "Review", method: "POST", path: "review.json/") {
      NoResponse
    }
  }
`;

export const KeepAliveQuery = gql`
  query keepAlive {
    keepAlive @rest(type: "KeepAlive", path: "session.json/keepalive") {
      NoResponse
    }
  }
`;

export const LedgerQuery = gql`
  query ledgerAccounts($clientId: Number!) {
    ledgerAccounts(clientId: $clientId)
      @rest(type: "LedgerAccount", path: "ledgeraccount.json/client/:clientId") {
      id
      categoryId
      accountType
      code
      name
      isAddOn
      active
      order
      role
      details
      accountSettings
      internalNotes
    }
  }
`;

export const LedgerInternalNotesMutation = gql`
  mutation submitInternalNote($internalNotes: [Object!]!, $ledgerId: String!) {
    submitInternalNote(input: $internalNotes, ledgerId: $ledgerId)
      @rest(type: "InternalNote", method: "PUT", path: "internalNotes.json/ledger/:ledgerId") {
      NoResponse
    }
  }
`;

export const LedgerPostInternalNoteMutation = gql`
  mutation postNewInternalNote($noteText: String!, $ledgerId: String!) {
    postNewInternalNote(input: $noteText, ledgerId: $ledgerId)
      @rest(type: "InternalNote", method: "POST", path: "internalNotes.json/ledger/:ledgerId") {
      NoResponse
    }
  }
`;

export const TransactionInternalNotesMutation = gql`
  mutation submitInternalNote($internalNotes: [Object!]!, $journalEntryId: String!) {
    submitInternalNote(input: $internalNotes, journalEntryId: $journalEntryId)
      @rest(type: "InternalNote", method: "PUT", path: "internalNotes.json/je/:journalEntryId") {
      NoResponse
    }
  }
`;

export const TransactionPostInternalNoteMutation = gql`
  mutation postNewInternalNote($noteText: String!, $journalEntryId: String!) {
    postNewInternalNote(input: $noteText, journalEntryId: $journalEntryId)
      @rest(type: "InternalNote", method: "POST", path: "internalNotes.json/je/:journalEntryId") {
      NoResponse
    }
  }
`;

export const ReviewHistoryPeriodQuery = gql`
  query reviewHistory($clientId: Number!) {
    reviewHistoryPeriod(clientId: $clientId)
      @rest(type: "ReviewHistoryPeriod", path: "review.json/client/:clientId") {
      id
      notes
      status
      fromMonth
      toMonth
      submittedAt
      submitterId
    }
  }
`;

export const ReviewHistoryMonthlyQuery = gql`
  query reviewHistory($clientId: Number!) {
    reviewHistoryMonthly(clientId: $clientId)
      @rest(type: "ReviewHistoryMonth", path: "review.json/client/:clientId/monthly") {
      month
      reviews {
        id
        notes
        status
        fromMonth
        toMonth
        submittedAt
        submitterId
      }
    }
  }
`;

export const BookkeepersQuery = gql`
  query bookkeepers {
    bookkeepers @rest(type: "Bookkeeper", path: "person.json/bookkeeper/") {
      id
      email
      firstName
      fullName
      lastName
      phone
    }
  }
`;
